import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1300.007,676.9996 C1485.521,676.9996 1636.515,827.9376 1636.515,1013.5066 L1636.515,1013.5066 L1636.515,1246.9996 L1779.015,1246.9996 L1779.015,1761.6316 C1779.015,1848.9856 1707.985,1920.0146 1620.632,1920.0146 L1620.632,1920.0146 L979.382,1920.0146 C892.029,1920.0146 821,1848.9856 821,1761.6316 L821,1761.6316 L821,1246.9996 L963.5,1246.9996 L963.5,1013.5066 C963.5,827.9376 1114.492,676.9996 1300.007,676.9996 Z M1581.1771,338.8234 L1581.1771,564.7054 L1468.2351,564.7054 L1468.2351,451.7644 L451.7651,451.7644 L451.7651,1468.2354 L564.7061,1468.2354 L564.7061,1581.1764 L338.8241,1581.1764 L338.8241,338.8234 L1581.1771,338.8234 Z M1300.007,780.0146 C1171.294,780.0146 1066.515,884.7936 1066.515,1013.5066 L1066.515,1013.5066 L1066.515,1246.9996 L1533.5,1246.9996 L1533.5,1013.5066 C1533.5,884.7936 1428.721,780.0146 1300.007,780.0146 Z M1242.353,0 L1242.353,225.882 L1129.412,225.882 L1129.412,112.941 L112.941,112.941 L112.941,1129.412 L225.882,1129.412 L225.882,1242.352 L5.68434189e-14,1242.352 L5.68434189e-14,0 L1242.353,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBlueprintLockSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconBlueprintLockSolid, _Component);

  var _super = _createSuper(IconBlueprintLockSolid);

  function IconBlueprintLockSolid() {
    _classCallCheck(this, IconBlueprintLockSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconBlueprintLockSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBlueprintLock",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBlueprintLockSolid.displayName = "IconBlueprintLockSolid";
  return IconBlueprintLockSolid;
}(Component);

IconBlueprintLockSolid.glyphName = 'blueprint-lock';
IconBlueprintLockSolid.variant = 'Solid';
IconBlueprintLockSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBlueprintLockSolid;
export { IconBlueprintLockSolid };